import { Box, CircularProgress, Fab, Grid, TextField, Typography } from '@material-ui/core';
import { lazy, Suspense, useState } from 'react';
import CustomerReviewHubTable from './customer-review-hub-table';
import SearchIcon from '@material-ui/icons/Search';
import CustomerRootPageDrawer from 'components/customer/components/CustomerDrawer/CustomerRootPageDrawer';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import MergeIcon from '@mui/icons-material/Merge';
import SyncIcon from '@mui/icons-material/Sync';
import FilterReviewHubDrawer from './drawers/filter-review-hub-drawer';
import { CustomerDuplicateResponse, CustomerReviewHubDto, FilterRequest } from '../model/customer-review-hub';
import DuplicateCustomerModal from './modals/duplicate-customers-modal';
import PreviewMergeModal from './modals/preview-merge-modal';
import customersReviewHubApi from '../api/customers-review-hub-api';
import AppSnackBar from 'components/snackbar/snackbar';
import { useAppSelector } from 'app';
import { DmsTypeEnum } from 'common/enums/DmsTypeEnum';

const CustomersReviewHub = ({
  filterRequest,
  selectedCustomers,
  setSelectedCustomers,
  setFilterDrawerOpen,
}: {
  filterRequest: FilterRequest;
  selectedCustomers: CustomerReviewHubDto[];
  setSelectedCustomers: (customers: CustomerReviewHubDto[]) => void;
  setFilterDrawerOpen: (val: boolean) => void;
}) => {
  const [customerSearchText, setCustomerSearchText] = useState<string>('');
  const [refreshGrid, setRefreshGrid] = useState<boolean>(false);
  let dmsTypeId = useAppSelector((state) => state.user.dmsTypeId);

  // Hiding the merge functionality as will be required in future
  // const [selectedDuplicateCustomers, setSelectedDuplicateCustomers] = useState<CustomerDuplicateResponse[]>([]);

  // const [duplicateModalOpen, setDuplicateModalOpen] = useState<boolean>(false);
  // const handlerDuplicateModelOpen = () => setDuplicateModalOpen(true);
  // const handlerDuplicateModelClose = (refresh = false) => {
  //   setDuplicateModalOpen(false);
  //   setSelectedCustomers([]);
  //   setSelectedDuplicateCustomers([]);
  //   if (refresh) {
  //     setRefreshGrid(!refreshGrid);
  //   }
  // };

  // const [previewModalOpen, setPreviewModalOpen] = useState<boolean>(false);
  // const handlerPreviewModalOpen = () => setPreviewModalOpen(true);
  // const handlerPreviewModalClose = () => setPreviewModalOpen(false);

  const [syncLoader, setSyncLoader] = useState<boolean>(false);
  const [showSnackBar] = AppSnackBar.useSnackBar();

  const handlerSyncSelectedCustomers = async () => {
    try {
      const crmCustomerIds = selectedCustomers?.map((x) => x.id);
      setSyncLoader(true);
      await customersReviewHubApi.syncCustomersFromReviewHub(crmCustomerIds);
      setSelectedCustomers([]);
      setRefreshGrid(!refreshGrid);
      showSnackBar({
        type: 'success',
        message: `The ${
          crmCustomerIds?.length > 1 ? 'customers have' : 'customer has'
        }  been successfully synced with the DMS.`,
      });
    } catch (error) {
      showSnackBar({ type: 'error', message: 'Unable to sync customer.' });
    }
    setSyncLoader(false);
  };

  return (
    <Box style={{ height: 'auto' }}>
      <Box>
        <Grid item xs={11}>
          <TextField
            fullWidth
            style={{ backgroundColor: 'white' }}
            margin="dense"
            variant="outlined"
            name="searchText"
            id="search-text"
            placeholder="Search customers"
            value={customerSearchText}
            InputProps={{
              startAdornment: <SearchIcon color="disabled" style={{ paddingRight: '5px' }} />,
            }}
            onChange={({ target: { value } }): void => {
              setCustomerSearchText(value);
            }}
          />
        </Grid>
      </Box>
      <Box mt={2}>
        <Grid container>
          <Grid item xs={11}>
            <CustomerReviewHubTable
              customerSearchText={customerSearchText}
              filterRequest={filterRequest}
              refreshGrid={refreshGrid}
              selectedCustomers={selectedCustomers}
              setSelectedCustomers={setSelectedCustomers}
            />
            {/* Hiding the merge functionality as will be required in future */}
            {/* {selectedCustomers?.length > 0 && (
              <DuplicateCustomerModal
                open={duplicateModalOpen}
                selectedCustomer={selectedCustomers[0]}
                selectedDuplicateCustomers={selectedDuplicateCustomers}
                handlerClose={handlerDuplicateModelClose}
                handlerPreviewModalOpen={handlerPreviewModalOpen}
                setSelectedDuplicateCustomers={setSelectedDuplicateCustomers}
              />
            )} */}
            {/* {selectedDuplicateCustomers?.length === 2 && (
              <PreviewMergeModal
                open={previewModalOpen}
                handlerClose={handlerPreviewModalClose}
                handlerDuplicateModelClose={handlerDuplicateModelClose}
                firstCustomer={selectedDuplicateCustomers[0]}
                secondCustomer={selectedDuplicateCustomers[1]}
              />
            )} */}
          </Grid>
          <Grid item xs={1}>
            <Box mb={10}>
              <Fab
                color="primary"
                onClick={() => {
                  setFilterDrawerOpen(true);
                }}
                style={{ marginLeft: 45 }}
                title="Filter">
                <Box sx={{ flexDirection: 'column', alignItems: 'center' }}>
                  <FilterAltIcon />
                  <Typography style={{ fontSize: '8px', marginTop: '-12px' }}>Filter</Typography>
                </Box>
              </Fab>
            </Box>
            {/* Hiding the merge functionality, as will be required in future */}
            {/* <Box mb={3}>
              <Fab
                color="primary"
                onClick={() => {
                  handlerDuplicateModelOpen();
                }}
                disabled={selectedCustomers?.length !== 1}
                style={{ marginLeft: 27 }}
                title="Merge">
                <Box sx={{ flexDirection: 'column', alignItems: 'center' }}>
                  <MergeIcon />
                  <Typography style={{ fontSize: '8px', marginTop: '-12px' }}>Merge</Typography>
                </Box>
              </Fab>
            </Box> */}
            <Box>
              <Fab
                color="primary"
                onClick={() => {
                  handlerSyncSelectedCustomers();
                }}
                disabled={selectedCustomers?.length === 0 || syncLoader}
                style={{ marginLeft: 45 }}
                title="Sync">
                {!syncLoader ? (
                  <Box sx={{ flexDirection: 'column', alignItems: 'center' }}>
                    <SyncIcon />
                    <Typography style={{ fontSize: '8px', marginTop: '-12px' }}>Sync</Typography>
                  </Box>
                ) : (
                  <CircularProgress style={{ color: 'white' }} />
                )}
              </Fab>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default function CustomersReviewHubPage() {
  const [selectedCustomers, setSelectedCustomers] = useState<CustomerReviewHubDto[]>([]);
  const [filterDrawerOpen, setFilterDrawerOpen] = useState<boolean>(false);
  const [filterRequest, setFilterRequest] = useState<FilterRequest>({
    reviewStatusOptions: [],
    targetSourceOptions: [],
    dateFrom: null,
    dateTo: null,
    fromMonth: 0,
    periodMonth: 6,
  });

  const setFiltersHanlder = (FiltersReq: FilterRequest) => {
    setFilterRequest(FiltersReq);
    setSelectedCustomers([]);
  };

  const FilterReviewHubDrawer = lazy(() => import('./drawers/filter-review-hub-drawer'));

  return (
    <>
      <CustomersReviewHub
        filterRequest={filterRequest}
        selectedCustomers={selectedCustomers}
        setSelectedCustomers={setSelectedCustomers}
        setFilterDrawerOpen={setFilterDrawerOpen}
      />
      {/*
      Lazy load FilterReviewHubDrawer
      */}
      {filterDrawerOpen && (
        <Suspense fallback={null}>
          <FilterReviewHubDrawer
            open={filterDrawerOpen}
            onClose={setFilterDrawerOpen}
            setFiltersHanlder={setFiltersHanlder}
          />
        </Suspense>
      )}
      {<CustomerRootPageDrawer />}
    </>
  );
}
